/**
 * Marks a navigation the app triggered on purpose, so leave guards do not challenge it.
 *
 * Applying a new build is a reload the user just asked for by pressing a button. Anything that
 * would normally ask "are you sure you want to leave?" has to stand down for it, otherwise the
 * user is prompted about their own click.
 *
 * The flag is one-way for the lifetime of the document: once an intentional navigation has been
 * marked, the page is on its way out and there is nothing left to protect. It resets naturally,
 * because the reload creates a new document.
 *
 * The app currently registers no `beforeunload` handler. If one is ever added, it must consult
 * {@link isIntentionalNavigation} before setting `returnValue`.
 */

let intentionalNavigation = false;

/** Call immediately before triggering a programmatic reload or navigation. */
export function markIntentionalNavigation(): void {
  intentionalNavigation = true;
}

/** True once the app has marked a navigation as intentional. */
export function isIntentionalNavigation(): boolean {
  return intentionalNavigation;
}

/** Test-only reset; the flag otherwise dies with the document. */
export function resetIntentionalNavigation(): void {
  intentionalNavigation = false;
}
